(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["prod-accordion"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.prod-accordion details').forEach(el => {
  const icon = el.querySelector('.toggle-icon');
  el.addEventListener('toggle', () => {
    if (el.open) {
      // close others
      document.querySelectorAll('.prod-accordion details').forEach(other => {
        if (other !== el) other.removeAttribute('open');
      });
      icon.textContent = '−';
    } else {
      icon.textContent = '+';
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
